export const Language = {
  moneySignBeRight: false, //货币符号是否在后面
  moneySign: 'Rs',

  newAPPVersionTip: 'New version available. Please refresh to continue playing.',
  NetworkError: 'Network issue. Try refresh or relogin. Need help? Contact support.',
  NetworkTimeout: 'Network timeout',

  user_kicked_out: "Because your account is logged in elsewhere, you've been kicked out",

  ConfigError: 'Get game config fail. Try refresh or relogin. Need help? Contact support.',

  LoadBundlesError: 'Load bundles fail. Try refresh or relogin. Need help? Contact support.',
  HotUpdateError: 'Load assets fail. Try refresh or relogin. Need help? Contact support.',

  exit_game_title: 'Tips',
  exit_game_btn_yes: 'Yes',
  exit_game_btn_no: 'No',
  exit_game_confirm: 'Are you sure you want to exit this game?',
  open_pay_url_confirm:
    "You will be redirected to a trusted third-party site verified by 777 Vegas. Tap 'Yes' to continue securely.",

  MessageID_Error: 'Waiting for short-term issuance',
  MobileNumInvalid: 'Please input valid Phone Number',
  PwdInvalid: 'Invalid password',
  InvalidSmscode: 'Please input valid OTP',
  OTPHasSent: 'The OTP has been sent.',
  BindPhoneSuccess: 'Mobile added successfully.\nReturn to lobby, start earning!',

  Not_sign: 'This event is only for VIP players. Recharge now to become VIP!',

  VipCardItem_days: 'Days',
  VipCardItem_reward_now: 'GET %s CASH+%s BONUS NOW', //立即获得%d现金+%d奖金
  VipCardItem_reward_everyDay: 'GET %s CASH+ %s BONUS EVERYDAY', //每天获得%d现金+%d奖金
  VipCardItem_cash_everyDay: 'GET %s CASH EVERYDAY', //每天获得%d现金
  VipCardItem_bouns_everyDay: 'GET %s BONUS EVERYDAY', //每天获得%d奖金
  VipCardItem_try_later: 'Payment in progress, please try again later.', //付款正在进行中，请稍后再试。
  Buy_vip_success: 'VIP Privileges Purchased!',
  Get_vip_reward_success: 'Rewards Received!',
  PayChannel_toast: 'Deposit is in progress. Please wait patiently.',

  Vip_Unlocks: 'Unlocks at ≥',
  ShareModule_click_link: 'Hello my firend! Click link and win big cash online now!', //你好，我的朋友!点击链接，立即在线赢取大额现金！
  ShareModule_whatapp_tip: 'Please install WhatsApp first.', //请先安装WhatsApp
  ShareModule_Facebook_tip: 'Please install Facebook first.', //请先安装Facebook
  ShareText_loadingNum: '/%s Valid Friends',
  ShareText_loadingNum2: '/%s Valid %s Friends',
  ShareText_rule_reward: "Friend's First Deposit = You Get:%s",
  ShareText_rule_pay: "Friend's Every Deposit = You Get:%s",

  ShareText_rule_level: '≥%s friends(Lv.1+Lv.2) completed 1-ST Deposit',

  modify_nickname_success: 'modify nick name success',
  modify_user_icon_success: 'modify user icon success',

  WithdrawPanel_add_bank: 'Please add a bank account first.', //请先添加银行账户.
  withdraw_error_1: 'The Pay TM ID is incorrect!',
  withdraw_error_2: 'The email format is incorrect!',
  withdraw_error_3: 'The withdrawal amount is null!',
  withdraw_error_4: 'Minimum cash withdrawal is %d.',
  withdraw_error_5: 'verification code sent',
  withdraw_error_6: 'Verification code error!',
  withdraw_error_7: 'BankInfo error',
  WithdrawPremiumTips: 'Only VIP can withdraw. Recharge now to become VIP!',
  WithdrawSuccessDialog:
    'Withdrawal successful. Arrives in 15 min - 24 hrs. Contact support if needed.',
  dialog_title_tips: 'Tips',
  h5_get_user_scores_fail: 'The network is poor, please try to connect again.',
  h5_get_user_scores_confirm: 'Connect',
  withdraw_tips_content:
    "Today's withdrawal limit used up. Come back tomorrow or upgrade VIP for more daily limits!",
  withdraw_tips_confirm: 'Confirm',
  FillEWalletDialogRs_invalid_number:
    'Invalid account number. The account number should not start from 0.', //帐号无效。帐号不应从0开始。
  FillBankInfoDialog_add_bank_success: 'Add Bank Card Success', //添加银行卡成功
  beneficiary_name: 'Enter Beneficiary Name', //输入受益人姓名
  BankInfoForms_bank_number: 'Enter Bank Account Number', //输入银行账号
  EWalletInfoForms_ewallet_number: 'Enter EWallet Account Number', //输入电子钱包账号
  EWalletInfoForms_valid_bank_number: 'Please enter a valid EWallet Account Number', //请输入有效的电子钱包账号
  EWalletInfoForms_same_ewallet_number: 'EWallet Account Number input must be the same', //电子钱包账号输入必须相同
  EWalletInfoForms_name: 'Enter Account Name', //输入账户名字
  EWalletInfoFormsRs_name: '03 xxxxxxxxx', //"Enter Account Number",  //输入账号
  EWalletInfoFormsRs_ID_number: '03 xxxxxxxxx', //"Enter ID Card Number",  //输入身份证号码
  FillBankInfoDialog_IFSC_number: 'Enter IFSC Code Number', //输入IFSC代码
  EWalletInfoFormsRs_valid_name: 'Please enter a valid Account Name', //请输入有效的账户
  EWalletInfoFormsRs_valid_number: 'Please enter a valid Account Number', //请输入有效的帐号
  EWalletInfoFormsRs_same_number: 'Account Number input must be the same', //帐号输入必须相同
  EWalletInfoFormsRs_valid_ID_number: 'Please enter a valid ID Card Number', //请输入有效的身份证号码
  FillBankInfoDialog_valid_IFSC_number: 'Please enter a valid IFSC Code Number', //请输入有效的IFSC代码
  FillBankInfo_Error: 'IFSC Code is incorrect. Please enter it again.',
  FillBankInfoFifth_Error: "The 5th character of the IFSC Code must be '0'",
  valid_name: 'Please enter a valid Beneficiary Name', //请输入有效的受益人姓名
  bank_name: 'Enter Bank Name', //输入银行名称
  valid_bank_number: 'Please enter a valid Bank Account Number', //请输入有效的银行帐号
  same_bank_number: 'Bank Account Number input must be the same', //银行账号输入必须相同
  valid_bank_name: 'Please enter a valid Bank Name', //请输入有效的银行名称
  houseRace_winTxet: 'Congrats! %s win %s in %s!', //跑马灯恭喜中奖
  tips: 'Tips', //提示
  confirm: 'CONFIRM', //确认
  notice: 'notice', //通知
  Notice: 'Notice', //通知大写
  yes: 'YES', //是的
  no: 'NO', //不是

  transaction_no_more_data: 'transaction no more data',
  transaction_is_first_page: 'transaction is first page',
  AddCashModule_failFun_tip: 'Please check the network and try again', //请检查网络并重试
  AddCashPayH5: 'Please click the button again after %s seconds',

  can_find_subgame_info: 'Can not find the game info',
  subgame_is_closed: 'This game comming soon',

  VipEquityView_showLevelUi_Recharge: 'Recharge %s to become VIP%s ',
  VipEquityView_showCloseTip_weelpar: 'Weekly Betting amount ≥ %s',
  VipEquityView_showCloseTip_halfMonthpar: 'Half-Month Betting amount ≥ %s',
  VipEquityView_showCloseTip_Monthpar: 'Monthly Betting amount ≥ %s',

  TransactionPanel_activity: 'Activity', // 游戏记录 - 文字 - 活动
  TransactionPanel_money_add: 'Money Add', // 游戏记录 - 文字 - 添加货币
  TransactionPanel_withdrawal: 'Withdrawal', // 游戏记录 - 文字 - 退出
  TransactionPanel_win: 'Won ', // 游戏记录 - 文字 - 赢
  TransactionPanel_loss: 'Lost ', // 游戏记录 - 文字 - 输

  UnPay: 'in process', // 提现中
  FinishPay: 'success', // 成功
  PayFail: 'fail', // 提现失败

  WithdrawFail: 'Abnormal failure', // 提现异常失败
  WithdrawFailHandled: 'Exception failure has been handled', // 异常失败已处理
  WithdrawRejected: 'Rejected', // 提现已拒绝

  Vip_ERROR: 'Check the network',
  VipRewardGetToday: 'Received today',
  VipRewardTime: 'Will expire in ',
  PayAmount: 'Recharge amount ', // "充值金额:",
  Arrived: ' Received', // "已到账!",

  CopySuccess: 'Successfully copied.',
  CopyFail: 'Copy failed.',
  CopyString: '\nHello my firend! Click link and win big cash online now!', //复制后半段
  MoreClick: 'More Events will Coming Soon.',
  EggCapsuleStart: 'Start(%s)',
  EggCapsuleStartEnd: 'Starting',
  EggCapsuleErroe: 'Activity data error',
  Sharing_link_error: 'Sharing link error', //分享链接错误
  WelcomeTip1: '1-ST Deposit Rewards Get %s% Rewards',
  WelcomeTip2: '2-ND Deposit Rewards Get %s% Rewards',
  WelcomeTip3: '3-RD Deposit Rewards Get %s% Rewards',

  BindActivityReward: 'Welcome Rewards',
  BindActivityBonus: 'Diamonds Convert',
  BindActivityDailyCash: 'Daily Cash',
  BindActivityVipCard: 'VIP Card',
  BindActivityVIPPrivilege: 'VIP Pirvilege',
  BindActivityLuckyWheel: 'Lucky Wheel',
  BindActivityLuckyGacha: 'Lucky Gacha',
  BindActivityRich1: 'Reward Upto ',
  BindActivityRich2: 'Unlock Your Diamonds to Free Cash',
  BindActivityRich3: 'Claim Free Cash Everyday',
  BindActivityRich4: 'Rewards Upto ',
  BindActivityRich5: 'Claim your VIP rewards',
  BindActivityRich6:
    '<color=#FFFFFF>Refer Friends = </color><color=#FFD663>Rs 1777</color><color=#FFFFFF> Diamonds Free!</color>',
  BindActivityRich7: 'Spin to win iPhone 17 Pro ',
  BindActivityRich8:
    '<color=#FFFFFF>Refer & Win </color><color=#FFD663>Rs 2000</color><color=#FFFFFF> free cash!</color>',
  BindActivityRich9:
    '<color=#FFFFFF>Only First Deposit</color><color=#FFD663> → 110%</color><color=#FFFFFF> Bonus!</color>',
  BindActivityRich10:
    '<color=#FFFFFF>Unlock free cash up to </color><color=#FFD663>Rs 1,000,000</color></color>',
  BindActivityRich11:
    '<color=#FFFFFF>Up to</color><color=#FFD663>Rs 7777</color><color=#FFFFFF> Free!</color>',
  BindActivityRich12:
    '<color=#FFFFFF>Claim </color><color=#FFD663> Rs 77,777</color><color=#FFFFFF> Everyday!</color>',
  BindActivityRich13:
    '<color=#FFFFFF>Win </color><color=#FFD663>Rs 7777 </color><color=#FFFFFF>Or </color><color=#FFD663>Rs 500 </color><color=#FFFFFF>Spins!</color>',

  FreeSpinEverydayTip: 'Free Spins - Play Slots for FREE!',

  Game_type_name_palyer: 'Recently Played',
  Game_type_name_hot: 'Hot Games',
  Game_type_name_slots: 'Slots Games',
  Game_type_name_tableCard: 'Table & Card',
  Game_type_name_crash: 'Crash Games',
  Game_type_name_arcade: 'Arcade',
  Game_type_name_fishing: 'Fishing',
  Game_type_name_casino: 'Live Casino',
  Game_type_name_lottery: 'Lottery',

  Game_provider_All: 'All',
  Game_provider_PG: 'PG',
  Game_provider_JILI: 'JILI',
  Game_provider_SP: 'Spribe',
  Game_provider_CQ9: 'CQ9',
  Game_provider_EV: 'Evolution',
  Game_provider_PP: 'Pragmatic Play',
  Game_provider_JDB: 'JDB',
  Game_provider_TADA: 'TADA',
  Game_provider_RED: 'Red Tiger',
  Game_provider_FaChai: 'FaChai',
  Game_provider_BNG: 'BNG',
  Game_provider_Hacksaw: 'Hacksaw',
  Game_provider_Bgaming: 'Bgaming',
  Game_provider_NextSPIN: 'NextSPIN',
  Game_provider_WONWON: 'WONWON',
  Game_provider_AOG: 'AOG',
  Game_provider_V8: 'V8',
  Game_provider_InOut: 'InOut',
  Game_provider_KoolBet: 'KoolBet',
  Game_provider_Mini: 'Mini',

  SubgameInfoTip1: 'Low balance. Go to Deposit now.',
  SubgameInfoTip2: 'All balances can be used to place bets.',
  SubgameInfoTip3: 'Free Cash Balance cannot be used to bet in this game.',
  VipConversionTip:
    '<size=20><color=#ffffff>Diamonds will convert to Free Cash when you betting.\nYour conversion rate is </color>',
  vipCardUp: 'Getir',
  vipEquiteConversion1: '<size=14><color=#FFD223>VIP',
  vipEquiteConversion2: '<color=#ffffff> Conversion rate: </color>',

  rolloverAllType: 'ALL TYPE',
  rolloverDeposit: 'DEPOSIT',
  rolloverFreeCash: 'FREE CASH',
  RolloverALLSTATUS: 'ALL STATUS',
  RolloverNOTSTARTED: 'NOT STARTED',
  RolloverONGOING: 'ONGOING',
  RolloverCOMPLETED: 'COMPLETED',
  RolloverCANCELED: 'CANCELED',

  TurnTableTips: ' just claimed',
  TurnTableReward1: ' Macbook Pro 16-inch',
  TurnTableReward2: ' iPhone 17 Pro ',
  TurnTableReward3: ' Free Spin x2',
  TurnTableReward4: ' Free Spin x1',
  TurnTableReward5: ' Free Cash',
  TurnTableError: 'Deposit any amount to get 1 Spin chance.',

  updateLoading: 'Loading... %s%',
  vipCardRedTip: 'Get',
  vipTip: 'vipTip',

  rankDailyTimeTip: 'Statistics Time: 00:00-24:00, %s',
  rankWeekTimeTip: 'Statistics Time: %s 00:00 - %s 24:00',

  rankClickDailyTip: `<color=#fff9c0>You placed</color><color=#fddb1c> %sth </color><color=#fff9c0>in daily ranking and won</color>`,
  rankClickWeeklyTip: `<color=#fff9c0>You placed</color><color=#fddb1c> %sth </color><color=#fff9c0>in weekly ranking and won</color>`,

  vip_tip_withdrawal_desc2: '<color=#EBEBEB>Upgrade for more​​</color>',
  vip_tip_withdrawal_desc:
    '<color=#FF0000>VIP%s: %s Daily Withdrawals​.</color><color=#EBEBEB>Upgrade for more​​</color>',
  GameListAmount:
    '<color=#898989>Current </color><color=#ea4e51>%s/%s</color><color=#898989> Games</color>',

  PddBanlance2: '<color=FFD663>You did it! %s achieved. claim money now!</color>',
  PddBanlance:
    '<color=#ECEBEB>Just </color><color=#FFD663>%s </color><color=#ECEBEB>more until you can claim </color><color=#FFD663>%s!</color>',
  PddBanTip:
    '<color=#ECEBEB>Hot news! </color><b><color=#FFFFFF>%s </color></b><color=#ECEBEB>just claimed </color><b><color=#FFFFFF>%s!</color></b>',
  PddTurnTableError: 'Invite friends to register and bind their mobile number to get more spins.',
  PddGet2: 'Claimed! Check your wallet for details.',
  panelShowErroe: 'data error',
  Loggings: 'Logging',
  PddTurnTableError2: 'Please claim the reward',
  PddStatus1: 'Ongoing',
  PddStatus2: 'Success',
  PddStatus3: 'Expired',
  PddFreeCash: '%s Free Cash',
  PddDownTime: '( %ss )',
  achieved: 'achieved',

  gotoLine: 'You will be redirected to a third-party website. Click Yes to proceed.',
  MinBet: 'Min Bet​:  %s Rs',
  Logging: 'Logging in',

  UsernameTip: '4-12 letters/numbers only',
  Password: '6-12 letters/numbers only',
  Deleted: 'Deleted successfully!',
  IsKBZError: 'this KBZ Pay is linked to another username. Enter a different one.',
  ResigsterError: 'Device registration has reached the upper limit.',

  LoginNewSuccess: 'Account added successfully, please return and log in again!',
  UsernameError: 'Invalid Username! 4-12 letters/numbers only.',
  UsernameError2: 'Username taken! Please re-enter.',
  UsernameError3: 'Username not found! Re-enter or register.',
  UsernameError4: 'Enter the correct personal account name',
  PasswordError: 'Invalid password! 6-12 letters/numbers only.',
  PasswordError2: 'Password mismatch! Please re-enter.',
  PasswordError3: 'Incorrect password! Please re-enter.',
  PasswordError4: 'Username & phone number mismatch! Please re-enter.',
  PhoneError: 'Invalid phone number! Please re-enter.',
  PhoneError2: 'Phone number taken! Please re-enter.',
  PhoneError3: 'The number entered does not match the Original Phone Number. Please check!',
  PhoneErrorotp: 'Invalid OTP, please re-enter',

  waterPar:
    '<color=#ffffff>Bet</color> <color=#FBE496> %s </color><color=#ffffff>more to unlock </color> <color=#FBE496> %s </color>',
  waterParSpin: '<color=#FBE496> %s </color><color=#ffffff>unlocked - Spin now!</color>',

  BonanzaParSpinNeed:
    '<color=#ffffff>Deposit </color><color=#FBE496> %s </color><color=#ffffff> more to claim </color><color=#FBE496> %s </color><color=#ffffff>bonus</color>',
  BonanzaParSpin:
    '<color=#ffffff>You have </color><color=#FBE496> %s </color><color=#ffffff>pending to claim</color>',
  BonanzaParSpinEnd:
    '<color=#ffffff>You have claimed </color><color=#FBE496> %s </color><color=#ffffff>bonus</color>',
  FirstTip: '%s just deposited %s',

  ClaimAll: 'Claim All',
  Claimed: 'Claim',
  TotalBetToday: 'Total Bet Today %s',
  TotalDepositToday: 'Total Deposit Today %s',
  DailyTaskReward: 'Daily Task Reward',
  MysteryTreasureReward: 'Mystery Treasure Reward',
  Claimsin: 'Claims in %s',
  MysticBoxTip:
    '<color=#ffffff>Daily Deposit ≥</color><color=#FFD663> Rs %s </color><color=#ffffff> To Get </color><color=#FFD663> %s </color></color><color=#ffffff> Claims </color>',
  enough: 'No enough chips!', // "金币不足",
  active: 'Active', //
  Failed: 'Failed',
  marqueLabel1: '<color=#FFFFFF>%s</color><color=#FFD663> Won %s 🎉</color>', //中奖的
  marqueLabel2: '<color=#FFFFFF>%s</color><color=#FFD663> deposited %s 🎉</color>', //充值的
  marqueLabel3: '<color=#FFFFFF>%s</color><color=#FFD663> withdrew %s 🎉</color>', //提现的
  jackLabel: '<color=#FFFFFF>Won </color>',
  friends: 'friends',
  Reachfriends: 'Reach VIP%s',
  jackpotTip: 'Please invite a friend to get a free spin',
  jackpotSpins: 'Spins Left: %s',

  WithdrawTips: 'Upgrade your VIP tier to get more withdrawal privileges.',
  otpTip: 'Please get the OTP first',
  AccountPanel_wallets: 'Wallets',
  AccountPanel_vip: 'VIP',
  AccountPanel_records: 'Records',
  AccountPanel_rollover: 'Rollover',
  AccountPanel_mail: 'Mail',
  AccountPanel_support: 'Support',
  AccountPanel_setting: 'Settings',
  AccountPanel_language: 'Language',
  AccountPanel_deposit: 'Deposit',
  AccountPanel_withdraw: 'Withdraw',
  Language_select_title: 'Select Language',
  Language_en: 'English',
  Language_pak: 'Urdu (اردو)',
}
